import {invokeMap, isEmpty, createSelector, moment, range, memoize} from 'helpers';
import {sorting} from 'store/sorting';
import {today} from 'store/common';

export const settings = createSelector(
  [ today, state => state.settings.today ],
  ( today, settings = {} ) => {
    const date = moment.parse(settings.date || today);
    let dates = [ date ];
    if (settings.period == 'three-days') {
      dates.unshift(date.clone().subtract(1, 'day'));
      dates.push(date.clone().add(1, 'day'));
    } else if (settings.period == 'week') {
      const startOfWeek = date.clone().startOf('week');
      dates = range(0, 7).map(index => startOfWeek.clone().add(index, 'day'));
    }
    return {
      ...settings,
      currentDate: date,
      dates: unpack(pack(dates)),
    }
  }
);

export const sort = createSelector(
  [ settings, sorting ],
  ( settings, sorting ) => ({
    ...settings,
    hasCustomOrder: !isEmpty(sorting),
  })
);

const pack = dates => invokeMap(dates, 'unix').join(',');

const unpack = memoize(timestamps => timestamps.split(',').map(moment.unix));
